import { createContext } from "react";
import type { MockBasketReview } from "@shared-core/mock-data/customer-portal-basket";

/**
 * Review tool, mock build only: a stand-in person to look at the portal as, because the mock has no
 * real sign-in to be anyone. The real portal has no personas and no way to be someone else: who you
 * are is the signed-in token (docs/features/customer-storefront/28_frontends_p4_update_spec.md
 * section 5.4). This file holds only the shapes, so the real build can read the (absent) context;
 * the persona list itself lives in `mock/MockPortalReviewRoot.tsx`, which only the mock build loads.
 */
export interface PortalReviewPersona {
  /** Matches mock-data/customer-portal.ts's PortalViewer.id. */
  id: string;
  name: string;
  jobTitle: string;
}

export interface PortalReviewControls {
  persona: PortalReviewPersona;
  personas: PortalReviewPersona[];
  setPersonaId: (id: string) => void;
}

/** Null in the real build, which has no review tool. */
export const PortalReviewContext = createContext<PortalReviewControls | null>(
  null,
);

/**
 * Review tool, mock build only: puts the current person's basket into a named state (empty, at the cap, a
 * price that moved) and sets what the next card payment or account order does, which the real backend
 * would reach through other people's actions. Null in the real build.
 */
export const PortalBasketReviewContext = createContext<MockBasketReview | null>(
  null,
);
